import { EmptyState } from '@components/EmptyState/EmptyState.tsx';
import { FilterIcon } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface NoFilteredResultsProps {
	onClear?: () => void;
}

export const NoFilteredResults: FC<NoFilteredResultsProps> = ({ onClear }) => {
	const { t } = useTranslation('', { keyPrefix: 'filters' });
	return (
		<EmptyState
			buttonProps={
				onClear
					? {
							children: t('clear'),
							variant: 'secondary',
							onClick: onClear,
						}
					: undefined
			}
			icon={<FilterIcon />}
			subTitle={t('noResultsDescription')}
			title={t('noResults')}
		/>
	);
};
